<h2 mat-dialog-title>Admin Set Level</h2>

<mat-dialog-content>

   <select [(ngModel)]="level">
      <option *ngFor="let l of levels" [value]="l.id">{{l.id}} - {{l.nameLong}}</option>
   </select>
</mat-dialog-content>

<mat-dialog-actions style="float: right;">
   <a href="#" (click)="cancel($event)">Cancel</a>
   &nbsp;&nbsp;
   <button class="" (click)="save()">Save</button>
</mat-dialog-actions>